<template>
	<!-- 入库 -->
	<!-- 表格 -->
	<div class="retrieval">
		<div class="title">样本管理 _入库</div>
		<a-table
				:scroll="{x:1515}"
				class="hospital-table"
				size="middle"
				:pagination="false"
				:dataSource="data"
				:rowKey="record => record.id"
		>
			<a-table-column :width="50" :customRender="(text, record, index) => `${index + 1}`">
				<span class="table-th" slot="title">序号</span>
			</a-table-column>
			<a-table-column :width="130">
				<span class="hospital-required table-th" slot="title">流转机构</span>
				<template slot-scope="text,record">
					{{record.deptName}}
				</template>
			</a-table-column>
			<a-table-column :width="130">
				<span class="table-th" slot="title">测序中心条码</span>
				<template slot-scope="text, record">
					{{record.barCode}}
				</template>
			</a-table-column>
			<a-table-column :width="95">
				<span class="table-th" slot="title">检测项目</span>
				<template slot-scope="text, record">
					{{record.applyItemNameDict}}
				</template>
			</a-table-column>
			<a-table-column :width="95">
				<span class="table-th" slot="title">专业组</span>
				<template slot-scope="text, record">
					{{record.groupName}}
				</template>
			</a-table-column>
			<a-table-column :width="130">
				<span class="hospital-required table-th" slot="title">协作组条码</span>
				<template slot-scope="text, record">
					{{record.hosBarCode}}
				</template>
			</a-table-column>
			<a-table-column :width="100">
				<span class="hospital-required table-th" slot="title">样本类型</span>
				<template slot-scope="text, record">
					{{record.sampleTypeNameDict}}
				</template>
			</a-table-column>
			<a-table-column :width="110">
				<span class="hospital-required table-th" slot="title">样本量（ml）</span>
				<template slot-scope="text, record">
					{{record.sampleAmount}}
				</template>
			</a-table-column>
			<a-table-column :width="130">
				<span class="hospital-required table-th" slot="title">入库日期</span>
				<template slot-scope="text, record,index">
					<div :class="{'has-error':isSubmit&&!record.createDate}">
						<!--:getCalendarContainer="triggerNode => triggerNode.parentNode"-->
						<a-date-picker
								:disabledDate="disabledEndDate"
								:defaultValue="record.createDate?moment(record.createDate, dateFormat):null"
								:format="dateFormat"
								@change="dataChange($event,$event._d,index,'createDate')"
								style="width: 150px"/>
					</div>
				</template>
			</a-table-column>
			<a-table-column :width="270">
				<span class="hospital-required table-th" slot="title">样本编号</span>
				<template slot-scope="text, record,index">
					<div :class="{'has-error':isSubmit&&!record.sampleId}">
						<a-input
								style="margin: -5px 0;width: 270px"
								:value="record.sampleId"
								@change="e => handleChange(e.target.value, index,'sampleId')"
						/>
					</div>
				</template>
			</a-table-column>
			<a-table-column :width="130">
				<span class="hospital-required table-th" slot="title">存储位置</span>
				<template slot-scope="text, record,index">
					<div :class="{'has-error':isSubmit&&!record.address}">
						<a-input
								style="margin: -5px 0;width: 130px"
								:value="record.address"
								placeholder="一罐一层一格"
								@change="e => handleChange(e.target.value, index,'address')"
						/>
					</div>
				</template>
			</a-table-column>
		</a-table>
		<div class="confrim-footer">
			<a-button type="primary" @click="retrievalSubmit" class="confirm-primary">提交</a-button>
		</div>
	</div>
</template>

<script>
    import moment from 'moment';

    export default {
        props: {
            list: {
                type: Array,
                default: []
            }
        },
        data() {
            return {
                dateFormat: 'YYYY-MM-DD',
                data: this.list,
                isSubmit: false,
                deptAry: [
                    {
                        key: 0,
                        value: "康圣达*****专业组"
                    },
                    {
                        key: 1,
                        value: "****测序中心"
                    }
                ]
            };
        },
        mounted() {
        },
        methods: {
            moment,
            disabledEndDate(current){
                return current && current > moment().endOf('day');
            },
            handleChange(value, key, column) {
                const newData = [...this.data];
                const target = newData[key];
                if (target) {
                    target[column] = value;
                    this.data = newData;
                }
            },
            dataChange(dateFormat, value, key, column) {
                const newData = [...this.data];
                const target = newData[key];
                if (target) {
                    target[column] = moment(value).format(this.dateFormat);
                    this.data = newData;
                }
            },
            retrievalSubmit() {
                const dataVo = [];
                this.isSubmit = true;
                this.data.forEach(function (item, i) {
                    let json = {};
                    json.address = item.address;
                    json.createDate = item.createDate;
                    json.id = item.id;
                    json.sampleId = item.sampleId;
                    dataVo.push(json);
                });
                this.$nextTick(() => {
                    let errList = document.querySelectorAll(".has-error");
                    if (errList.length == 0) {
                        this.$post("sampleinfo/putBatch", dataVo,
                            {
                                "Content-Type": "application/json"
                            }).then(
                            res => {
                                if (res.data.code == 1) {
                                    this.$message.success("样本入库成功!");
                                    this.$emit('clearSelected');
                                } else {
                                    this.$message.error(res.data.message);
                                }
                                this.$emit("close");
                            },
                            error => {
                                this.$message.error("样本入库失败!");
                            });
                    }
                })

            },

        }
    };
</script>

<style lang="scss" scoped>
	.retrieval {
		.title {
			padding: 82px 0 56px 0;
			font-size: 26px;
			font-family: PingFang SC;
			font-weight: 400;
			color: rgba(51, 51, 51, 1);
		}
		.confirm-primary {
			width: 100%;
		}
	}

	.table-th {
		color: #a4a4a4;
	}
</style>